const getEmbedURL = (id) => (
  `https://giphy.com/embed/${id}`
);

export default getEmbedURL;
